import type { ChatBotDataT, EditDeleteSessionT, FeedbackT, ReactionT } from '../components/ChatBotScreen/ChatConversationSection/types'
import axiosInstance from './apiInstance'

// Chat Endpoint
export const chatBotAPI = async (chatData: ChatBotDataT, platform: string | null, botType: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.post('/chat', chatData, { headers: { platform, bot_type: botType } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// Microsoft User Login Endpoint
export const microsoftUserLoginAPI = async (loginData: { token: string }): Promise<any> => {
  try {
    const response = await axiosInstance.post('/user/login/microsoft', loginData)
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// Get default manufacture list
export const getAllManufacturersAPI = async (platform: string | null, botType: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.get('/manufacturer/all', { headers: { platform, bot_type: botType } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// Get default operator list
export const getAllOperatorsAPI = async (platform: string | null, botType: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.get('/operator/search', { headers: { platform, bot_type: botType } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// Get serached operator list
export const getAllOperatorsByInputAPI = async (inputValue: string, limit: number, platform: string | null, botType: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/operator/search?name=${inputValue}&limit=${limit}`, { headers: { platform, bot_type: botType } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// send response Reaction
export const sendResponseReaction = async (chatRecordId: string | undefined, feedback: ReactionT | FeedbackT, platform: string | null, botType: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.patch(`/chat/record/feedback/${chatRecordId}`, feedback, { headers: { platform, bot_type: botType } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}

// Get searched messages by session ID
export const getSessionChatHistory = async (sessionId: string | null, platformId: string[] | null, platform: string | null, botType: string | null): Promise<any> => {
  if (sessionId !== null) {
    try {
      const response = await axiosInstance.get(`/chat/record/search?session_id=${sessionId}&platform_id=${platformId?.toString()}`, { headers: { platform, bot_type: botType } })
      return response.data
    } catch (error) {
      console.log('Error', error)
      throw error
    }
  }
}

// Edit session ID name or delete session
export const editDeleteSession = async (sessionId: string, changedSession: EditDeleteSessionT, platform: string | null, botType: string | null): Promise<any> => {
  if (sessionId !== null) {
    try {
      const response = await axiosInstance.patch('/chat/record/session', changedSession, { headers: { platform, bot_type: botType } })
      return response.data
    } catch (error) {
      console.log('Error', error)
      throw error
    }
  }
}

// Get list of all sessions
export const getAllSessions = async (platform: string | null, platformId: string, email: string, limit: string | null): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/chat/record/history?platform_id=${platformId}&platform=${platform}&user_email=${email.replaceAll('+', '%2B')}&limit=${limit}`, { headers: { platform } })
    return response.data
  } catch (error) {
    console.log('Error', error)
    throw error
  }
}
